export const GetIANATimeZoneName = (spTimeZoneId: string): string | null => {
    return SPTimeZoneIdToIANATimeZoneName[spTimeZoneId] ?? null;
}

const SPTimeZoneIdToIANATimeZoneName = {
    "2": "Europe/London",
    "3": "Europe/Paris",
    "4": "Europe/Berlin",
    "5": "Europe/Bucharest",
    "6": "Europe/Budapest",
    "7": "Europe/Kaliningrad",
    "8": "America/Sao_Paulo",
    "9": "America/Halifax",
    "10": "America/New_York",
    "11": "America/Chicago",
    "12": "America/Denver",
    "13": "America/Los_Angeles",
    "14": "America/Anchorage",
    "15": "Pacific/Honolulu",
    "16": "Pacific/Apia",
    "17": "Pacific/Auckland",
    "18": "Australia/Brisbane",
    "19": "Australia/Adelaide",
    "20": "Asia/Tokyo",
    "21": "Asia/Singapore",
    "22": "Asia/Bangkok",
    "23": "Asia/Kolkata",
    "24": "Asia/Dubai",
    "25": "Asia/Tehran",
    "26": "Asia/Baghdad",
    "27": "Asia/Jerusalem",
    "28": "America/St_Johns",
    "29": "Atlantic/Azores",
    "30": "Etc/GMT+2",
    "31": "Atlantic/Reykjavik",
    "32": "America/Cayenne",
    "33": "America/La_Paz",
    "34": "America/Indianapolis",
    "35": "America/Bogota",
    "36": "America/Regina",
    "37": "America/Mexico_City",
    "38": "America/Phoenix",
    "39": "Etc/GMT+12",
    "40": "Pacific/Fiji",
    "41": "Asia/Magadan",
    "42": "Australia/Hobart",
    "43": "Pacific/Port_Moresby",
    "44": "Australia/Darwin",
    "45": "Asia/Shanghai",
    "46": "Asia/Novosibirsk",
    "47": "Asia/Tashkent",
    "48": "Asia/Kabul",
    "49": "Africa/Cairo",
    "50": "Africa/Johannesburg",
    "51": "Europe/Moscow",
    "53": "Atlantic/Cape_Verde",
    "54": "Asia/Baku",
    "55": "America/Guatemala",
    "56": "Africa/Nairobi",
    "57": "Europe/Warsaw",
    "58": "Asia/Yekaterinburg",
    "59": "Europe/Kiev",
    "60": "America/Godthab",
    "61": "Asia/Rangoon",
    "62": "Asia/Katmandu",
    "63": "Asia/Irkutsk",
    "64": "Asia/Krasnoyarsk",
    "65": "America/Santiago",
    "66": "Asia/Colombo",
    "67": "Pacific/Tongatapu",
    "68": "Asia/Vladivostok",
    "69": "Africa/Lagos",
    "70": "Asia/Yakutsk",
    "71": "Asia/Almaty",
    "72": "Asia/Seoul",
    "73": "Australia/Perth",
    "74": "Asia/Riyadh",
    "75": "Asia/Taipei",
    "76": "Australia/Sydney",
    "77": "America/Chihuahua",
    "78": "America/Santa_Isabel",
    "79": "Asia/Amman",
    "80": "Asia/Beirut",
    "81": "America/Manaus",
    "82": "Asia/Tbilisi",
    "83": "Africa/Windhoek",
    "84": "Asia/Yerevan",
    "85": "America/Buenos_Aires",
    "86": "Africa/Casablanca",
    "87": "Asia/Karachi",
    "88": "America/Caracas",
    "89": "Indian/Mauritius",
    "90": "America/Montevideo",
    "91": "America/Asuncion",
    "92": "Asia/Kamchatka",
    "93": "UTC",
    "94": "Asia/Ulaanbaatar",
    "95": "Etc/GMT+11",
    "96": "Etc/GMT+2",
    "97": "Etc/GMT-12",
    "98": "Asia/Damascus",
    "99": "Asia/Magadan",
    "100": "Europe/Kaliningrad",
    "101": "Europe/Istanbul",
    "102": "Asia/Dhaka",
    "103": "America/Bahia"
};